import { createContext } from 'react';
import dayjs from 'dayjs';
// dayjs does not properly support ESM syntax -- adding the extension here allows rollup to transpile properly
import customParseFormat from 'dayjs/plugin/customParseFormat.js';

import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { ComponentPropsWithoutRef, FC } from 'react';
import { datavant, datavantResolver } from './datavant';
import { DatesProvider, DatesProviderProps } from '@mantine/dates';

dayjs.extend(customParseFormat);

type DartContext = {
    environment: 'staging' | 'production';
};

export const DartContext = createContext<DartContext>({ environment: 'production' });

export type DatavantProviderProps = ComponentPropsWithoutRef<typeof MantineProvider> & {
    datesProviderProps?: DatesProviderProps;
    environment?: DartContext['environment'];
};

export const DatavantProvider: FC<DatavantProviderProps> = ({
    children,
    theme = datavant,
    cssVariablesResolver = datavantResolver,
    datesProviderProps = {
        settings: {},
    },
    environment = 'production',
    ...mantineProviderProps
}) => {
    return (
        <DartContext.Provider value={{ environment }}>
            <DatesProvider {...datesProviderProps}>
                <MantineProvider
                    theme={theme}
                    cssVariablesResolver={cssVariablesResolver}
                    {...mantineProviderProps}
                >
                    <Notifications />
                    {children}
                </MantineProvider>
            </DatesProvider>
        </DartContext.Provider>
    );
};
